import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
const ToggleHeader = ({ 
  views = [], 
  activeView, 
  onViewChange, 
  actions = null,
  shouldHighlightUrgent = false 
}) => {
  const theme = useTheme();

  // Gentle pulse animation (professional & subtle)
  const pulseKeyframes = `
    @keyframes pulse-urgent {
      0% {
        box-shadow: 0 0 0 0 rgba(229, 62, 62, 0.4);
      }
      70% {
        box-shadow: 0 0 0 8px rgba(229, 62, 62, 0);
      }
      100% {
        box-shadow: 0 0 0 0 rgba(229, 62, 62, 0);
      }
    }
  `;

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    marginTop: '8px',
    paddingBottom: '16px',
    borderBottom: '2px solid transparent',
    borderBottomColor: 'divider',
    position: 'relative'
  };

  const viewsContainerStyle = {
    display: 'flex',
    gap: '32px',
    flex: '1',
    minWidth: '0'
  };

  const viewItemStyle = (isActive, isUrgentAndHighlighted) => ({
    cursor: 'pointer',
    transition: 'all 0.2s',
    paddingBottom: '2px',
    // Optional: add padding to accommodate glow
    padding: isUrgentAndHighlighted ? '0 4px' : '0',
    borderRadius: isUrgentAndHighlighted ? '4px' : '0',
    ...(isUrgentAndHighlighted && !isActive && {
      animation: 'pulse-urgent 2s infinite',
    })
  });

  const titleStyle = (isActive, isUrgentAndHighlighted) => {
    let base = {
      fontSize: '1.75rem',
      fontWeight: isActive ? '600' : '500',
      margin: '0 0 4px 0',
      color: isActive ? 'primary.main' : 'text.secondary',
      letterSpacing: '-0.02em',
      transition: 'all 0.2s'
    };

    // Always red if urgent AND highlighted (even when not active)
    if (isUrgentAndHighlighted) {
      base.color = 'error.main'; // red
    }

    return base;
  };

  const subtitleStyle = (isActive, isUrgentAndHighlighted) => ({
    color: isActive ? 'text.primary' : isUrgentAndHighlighted ? 'error.main' : 'text.secondary',
    fontSize: '0.95rem',
    margin: '0',
    fontWeight: '400',
    transition: 'all 0.2s'
  });

  const actionsStyle = {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    marginLeft: '24px'
  };

  const dotStyle = (activeIndex) => ({
    position: 'absolute',
    bottom: '-6px',
    left: `${activeIndex * 200}px`,
    width: '10px',
    height: '10px',
    backgroundColor: '#7091e6',
    borderRadius: '50%',
    border: '2px solid white',
    transition: 'left 0.3s ease'
  });

  const activeIndex = views.findIndex(view => view.id === activeView);

  return (
    <Box sx={headerStyle}>
      <style>{pulseKeyframes}</style>

      <Box sx={viewsContainerStyle}>
        {views.map((view) => {
          const isActive = view.id === activeView;
          const isUrgentAndHighlighted = view.id === 'urgent' && shouldHighlightUrgent;

          return (
            <Box
              key={view.id}
              sx={viewItemStyle(isActive, isUrgentAndHighlighted)}
              onClick={() => onViewChange(view.id)}
            >
              <Typography sx={titleStyle(isActive, isUrgentAndHighlighted)}>
                {view.title}
              </Typography>
              {view.subtitle && (
                <Typography sx={subtitleStyle(isActive, isUrgentAndHighlighted)}>
                  {view.subtitle}
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>

      {actions && <Box sx={actionsStyle}>{actions}</Box>}
      {/* Disable the dot style for MUI as it requires custom sx handling */}
    </Box>
  );
};

export default ToggleHeader;

// import React, { useState } from 'react';
// import { useTheme } from '@mui/material/styles';

// const ToggleHeader = ({ views = [], activeView, onViewChange, actions = null,
//     shouldHighlightUrgent = false
//  }) => {
//   const theme = useTheme();

//   // Add flicker keyframes via inline style (or use CSS class if preferred)
//   const flickerKeyframes = `
//     @keyframes flicker {
//       0%, 19%, 21%, 23%, 25%, 54%, 56%, 100% {
//         opacity: 1;
//       }
//       20%, 24%, 55% {
//         opacity: 0.4;
//       }
//     }
//   `;
//   const headerStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '24px',
//     paddingBottom: '16px',
//     borderBottom: '2px solid #e8eef7',
//     position: 'relative'
//   };

//   const viewsContainerStyle = {
//     display: 'flex',
//     gap: '32px',
//     flex: '1',
//     minWidth: '0'
//   };

//   const viewItemStyle = (isActive) => ({
//     cursor: 'pointer',
//     transition: 'all 0.2s',
//     paddingBottom: '2px'
//   });

//   const titleStyle = (isActive, isUrgentAndHighlighted) => {
//     let base = {
//       fontSize: '1.75rem',
//       fontWeight: isActive ? '600' : '500',
//       margin: '0 0 4px 0',
//       color: isActive ? '#3d52a0' : '#b0b7c8',
//       letterSpacing: '-0.02em',
//       transition: 'all 0.2s'
//     };

//     if (isUrgentAndHighlighted) {
//       base = {
//         ...base,
//         color: '#e53e3e', // red
//         animation: shouldHighlightUrgent ? 'flicker 1.5s infinite' : 'none'
//       };
//     }

//     return base;
//   };

//   const subtitleStyle = (isActive) => ({
//     color: isActive ? '#8b92a8' : '#c5cad7',
//     fontSize: '0.95rem',
//     margin: '0',
//     fontWeight: '400',
//     transition: 'all 0.2s'
//   });

//   const actionsStyle = {
//     display: 'flex',
//     gap: '12px',
//     alignItems: 'center',
//     marginLeft: '24px'
//   };

//   const dotStyle = (isActive, index) => ({
//     position: 'absolute',
//     bottom: '-6px',
//     left: isActive ? `${index * 200}px` : `${views.findIndex(v => v.id === activeView) * 200}px`,
//     width: '10px',
//     height: '10px',
//     backgroundColor: '#7091e6',
//     borderRadius: '50%',
//     border: '2px solid white',
//     transition: 'left 0.3s ease'
//   });
  

//   return (
//     <div style={headerStyle}>
//     {/* Inject flicker animation globally for this component */}
//       <style>{flickerKeyframes}</style>
//       <div style={viewsContainerStyle}>
//         {views.map((view, index) => (
//           <div 
//             key={view.id}
//             style={viewItemStyle(view.id === activeView)}
//             onClick={() => onViewChange(view.id)}
//           >
//             <h1 style={titleStyle(view.id === activeView)}>{view.title}</h1>
//             {view.subtitle && (
//               <p style={subtitleStyle(view.id === activeView)}>{view.subtitle}</p>
//             )}
//           </div>
//         ))}
//       </div>
//       {actions && (
//         <div style={actionsStyle}>
//           {actions}
//         </div>
//       )}
//       <div style={dotStyle(true, views.findIndex(v => v.id === activeView))}></div>
//     </div>
//   );
// };

